<div class="patient-header">
	<ng-container *ngIf="patient; else patientEmptyState">
		<tlk-account-icon class="patient-header__account-icon" />
		<info-cell
			class="patient-header__main-info-cell patient-header__grow--1"
			[title]="getPatientFullName(patient)"
			[value]="patient?.ChartNumber"
			type="main"
		/>

		<div class="patient-header__info-group patient-header__grow--7">
			<info-cell
				class="patient-header__grow--1"
				[title]="'IntuitivePatient.Age' | translate"
				[value]="patientAge ? patientAge + ' ' + ('IntuitivePatient.AgeYears' | translatePlural: patientAge) : '---'"
			/>
			<info-cell
				class="patient-header__grow--1"
				[title]="'IntuitivePatient.GenderAtBirth' | translate"
				[value]="(patient.Gender | gender) ? ('PatientSection.' + (patient.Gender | gender) | translate) : '---'"
			/>
			<info-cell
				class="patient-header__grow--1"
				[title]="'IntuitivePatient.LastScan' | translate"
				[value]="patient.LastScanDate ? (patient.LastScanDate | date: (dateFormat$ | async)) : '---'"
			/>

			<div class="patient-header__divider patient-header__grow--1">
				<div class="patient-header__divider-line"></div>
			</div>

			<rx-intuitive-doctor-license class="patient-header__grow--9" />
		</div>

		<button
			*ngIf="(isPatientSectionReadOnly$ | async) === false"
			tlkButton
			variant="ghost"
			size="l"
			class="patient-header__edit-button"
			[class.patient-header__edit-button--license-visible]="isLicenseEditable$ | async"
			(click)="toggleHeader()"
		>
			<tlk-loading-spinner *ngIf="patientAppLoading$ | async" [size]="32" class="button-spinner"></tlk-loading-spinner>
			<tlk-close-empty-icon *ngIf="(patientExpanded$ | async)  && (patientAppLoading$ | async) === false" class="patient-header__edit-icon" />
			<tlk-edit-icon *ngIf="(patientExpanded$ | async) === false  && (patientAppLoading$ | async) === false" class="patient-header__edit-icon" />
		</button>
	</ng-container>

	<ng-template #patientEmptyState>
		<ng-container *ngIf="isPatientCleared$ | async; else patientErrorMessage">
			<tlk-account-icon class="patient-header__account-icon" />
			<info-cell class="patient-header__main-info-cell patient-header__grow--1" title="---" value="---" type="main" />

			<div class="patient-header__info-group patient-header__grow--7">
				<info-cell class="patient-header__grow--1" [title]="'IntuitivePatient.Age' | translate" value="---" />
				<info-cell class="patient-header__grow--1" [title]="'IntuitivePatient.GenderAtBirth' | translate" value="---" />
				<info-cell class="patient-header__grow--1" [title]="'IntuitivePatient.LastScan' | translate" value="---" />

				<div class="patient-header__divider patient-header__grow--1">
					<div class="patient-header__divider-line"></div>
				</div>

				<rx-intuitive-doctor-license class="patient-header__grow--9" />
			</div>

			<button
				*ngIf="!(isPatientSectionReadOnly$ | async)"
				tlkButton
				variant="ghost"
				size="l"
				class="patient-header__edit-button"
				[class.patient-header__edit-button--license-visible]="isLicenseEditable$ | async"
				(click)="toggleHeader()"
			>
				<tlk-close-empty-icon *ngIf="patientExpanded$ | async" class="patient-header__edit-icon" />
				<tlk-edit-icon *ngIf="!(patientExpanded$ | async)" class="patient-header__edit-icon" />
			</button>
		</ng-container>
	</ng-template>

	<ng-template #patientErrorMessage>
		<div class="patient-header__info-group patient-header__info-group--error">
			Unable to load patient details.<i>*Needs mockups.</i>
		</div>
	</ng-template>
</div>

<div class="patient-header__expanded-area" *ngIf="patientExpanded$ | async" id="patient-app-edit">
	<ng-container [ngSwitch]="patientDisplayMode$ | async">
		<rx-patient-card *ngSwitchCase="patientDisplayMode.PatientCard" [appId]="patientCardHeaderId"  (patientAppReadyChange)="onPatientCardReadyChange($event)" />
		<iframe
			*ngSwitchDefault
			[attr.id]="patientAppId.Edit"
			[src]="expandedPatientAppUrl$ | async"
			class="patient-app-edit-iframe"
		></iframe>
	</ng-container>
</div>
